import {useModule} from "./useModule";


export const useAuth = () => {
    return useModule("auth");
};
